export default __webpack_public_path__ + "static/media/ref-gamma-medica.89d4f78f.pdf";